import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import ModalComponent from "../../../adminpanel/components/commonComponents/ModalComponent";
import Form from "../../../adminpanel/components/commonComponents/Form";
import CallAPI from '../../../adminpanel/components/commonComponents/AxiosHelper';
import exportFromJSON from 'export-from-json';
import AsyncSelect from 'react-select/async';
import { ExportToCsv } from 'export-to-csv';
import { toExcel } from 'to-excel';
import { bindActionCreators } from 'redux';
import { dataLabelConfig, setKpiColumnConfig } from '../../actions/index';

import DragAndDropComponents from './DragAndDropComponents'

const formUpload = {
    "saveReportForm": {
        "reportName": { "name": "reportName", "id": "reportName", "label": "Report Name", "type": "text","text_value":'', requiredFlag: true },
        "dataPeriod": {
            "name": "dataPeriod", "label": "Data Period", "type": "dropdown", "options": [
                { "name": "Select Data Period", "value": "" },
                { "name": "YTD", "value": "ytd" },
                { "name": "MTD", "value": "mtd" },
                { "name": "This Week", "value": "thisweek" },
                { "name": "Yesterday", "value": "yesterday" }
            ], requiredFlag: false
        },
        "toUser": {
            "name": "toUser", "label": "Share To", "type": "dropdown", "text_value": [], "options": [], multiple: true, requiredFlag: false
        },
        "freq_type": {
            "name": "freq_type", "label": "Frequency", "type": "dropdown", "options": [
                { "name": "Select Range", "value": "" },
                { "value": 'daily', "name": "Daily" },
                { "value": 'weekly', "name": "Weekly" },
                { "value": 'monthly', "name": "Monthly" },
                { "value": 'quarterly', "name": "Quaterly" },
                { "value": 'yearly', "name": "Yearly" },
                { "value": 'dates', "name": "Custom Dates" },
                { "value": 'weekdays', "name": "Only Weekdays" },
                { "value": 'weekends', "name": "Only Weekends" }
            ], requiredFlag: false
        },
        "timeOfDay": {
            "name": "timeOfDay", "label": "Time of the day", "type": "hide", "requiredFlag": false
        },
        "dayOfWeek": {
            "name": "dayOfWeek", "label": "Day of Week", "type": "hide",
            "options": [{ "name": "Select Option", "value": "" },
            { "name": "Sunday", "value": "sun" },
            { "name": "Monday", "value": "mon" },
            { "name": "Tuesday", "value": "tue" },
            { "name": "Wednesday", "value": "wed" },
            { "name": "Thursday", "value": "thu" },
            { "name": "Friday", "value": "fri" },
            { "name": "Saturday", "value": "sat" }
            ], requiredFlag: false
        },
        "dayOfMonth": {
            "name": "dayOfMonth", "label": "Day of Month", "type": "hide", "min": "1", "max": "31", requiredFlag: false
        },
        "channel": {
            "name": "channel", "label": "Channel", "type": "dropdown", "text_value": [], "options": [
                { "value": 'email', "name": "Email" },
                { "value": 'browser', "name": "Browser" }
            ], multiple: true, requiredFlag: false
        },
        "outputType": {
            "name": "outputType", "label": "Output Type", "type": "dropdown", "options": [
                { "name": "Select Option", "value": "" },
                { "name": "PDF", "value": "pdf" }
            ], requiredFlag: true
        },
        // "sampleReport": {
        //     "name": "sampleReport", "label": "Email Sample Report", "type": "checkbox", requiredFlag: false
        // }
    },
    "exportReportForm": {
        "fileName": { "name": "fileName", "label": "File Name", "type": "text", requiredFlag: true },
        "outputType": {
            "name": "outputType", "label": "Export Type", "type": "dropdown", "options": [], requiredFlag: true
        }
    },
    "chartConfigForm": {
        "chartConfiguration": {
            "name": "chartConfiguration", "label": "Update Datalabels", "text_value": '', "type": "dropdown", "options": [{ "name": "Select Configuration", "value": "" },
            { "name": "Enable All data labels", "value": "all" },
            { "name": "Enable Alternate data labels", "value": "alternate" },
            { "name": "Enable First and last data labels", "value": "firstLast" },
            ], requiredFlag: true
        },
        
        "yAxis": {
            "name": "yAxis", "label": "Enable Y-axis", "type": "hide", "text_value": '', "options": [{ "name": "Enable Y-axis", "value": "" }, { "name": "True", "value": true },
            { "name": "False", "value": false },
            ], requiredFlag: true
        },
    },
    "compareConfigForm": {
        "compareConfiguration": {
            "name": "compareConfiguration", "label": "", "text_value": '', "type": "dropdown", "options": [{ "name": "Select Option", "value": "" },
            { "name": "Growth", "value": "growth" },
            { "name": "Target", "value": "target" },
            ], requiredFlag: true
        },
     
    },
    "pinboardForm": {
        "typ": {
            "name": "typ", "label": "Select", "type": "hide", "options": [
                { "name": "Select option", "value": "" },
                { "name": "Dashboard", "value": "dashboard" },
                { "name": "Workbook", "value": "workbook" }
            ], requiredFlag: true
        },
        "isCopy": {
            "name": "isCopy", "label": "Copy as it is", "type": "hide", requiredFlag: false
        },
        "type": {
            "name": "type", "label": "Select Category", "type": "hide", "options": [
                { "name": "Select Category", "value": "" },
                { "name": "Local", "value": "local" },
                { "name": "Global", "value": "global" }
            ], requiredFlag: true
        },
        "workbook": {
            "name": "workbook", "label": "Select Workbook", "type": "hide", "options": [], requiredFlag: true
        },
        "new_name": { "name": "new_name", "label": "Name Dashboard", "type": "hide", requiredFlag: true },
        "dashboard_group": { "name": "dashboard_group", "label": "Name Workbook", "type": "hide", requiredFlag: true },
        "category": {
            "name": "category", "label": "Select Type", "type": "hide", "options": [
                { "name": "Select Type", "value": "" },
                { "name": "Static", "value": "static" },
                { "name": "Dynamic", "value": "dynamic" }
            ], requiredFlag: true
        }
    },
    "dashboardShareForm": {
        "user_list": {
            "name": "user_list", "label":"User List","type": "dropdown", multiple: true, requiredFlag: true, "options": [], 'text_value': []
        },
    },
    'componentsPerPageForm': {
        'components': {
            "name": "components", "label": "Components Per Page", "type": "dropdown", "options": [
                { "name": "Select Option", "value": "" },
                { "name": "2", "value": 2 },
                { "name": "3", "value": 3 },
                { "name": "4", "value": 4 },
                { "name": "5", "value": 5 },
                { "name": "6", "value": 6 },
                { "name": "7", "value": 7 },
                { "name": "8", "value": 8 },
                // { "name": "9", "value": 9 },
                // { "name": "10", "value": 10 },
                // { "name": "11", "value": 11 },
                // { "name": "12", "value": 12 }
            ], requiredFlag: true
        }
    },
    'configureKPIMColsForm': {
        'kpiMetaColumns': {
            "name": "kpiMetaColumns", "type": "dropdown", "options": [], multiple: true, requiredFlag: false
        }
    },
    'dashboardRangeForm': {
        "dashboardRange": {
            "name": "dashboardRange", "type": "dropdown", "options": [
                { "name": "Select Time Range", "value": "" },
                { "name": "Month till date", "value": "0_MTD" },
                { "name": "Year till date", "value": "0_YTD" },
                { "name": "Last quarter", "value": "0_LQ" },
                { "name": "Last 1 Month", "value": "1_month" },
                { "name": "Last 2 Month", "value": "2_month" },
                { "name": "Last 3 Month", "value": "3_month" },
                { "name": "Last 6 Month", "value": "6_month" },
                { "name": "Last 9 Month", "value": "9_month" },
                { "name": "Last 12 Month", "value": "12_month" },
                { "name": "Last 13 Month", "value": "13_month" },
                { "name": "Last 15 Month", "value": "15_month" },
                { "name": "Last 18 Month", "value": "18_month" },
                { "name": "Last 21 Month", "value": "21_month" },
                { "name": "Last 24 Month", "value": "24_month" },
                { "name": "Last 36 Month", "value": "36_month" }
            ], requiredFlag: true
        }
    }
}

const modalConfig = {
    "saveReportModal": {
        "id": "saveReportModal", "form_name": "saveReport", "form_id": "saveReportForm", "title": "Save Report", "body": null, "button_name": "Save", "buttonType": "submit", "display": true
    },
    "chartConfigModal": {
        "id": "chartConfigModal", "form_name": "chartConfig", "form_id": "chartConfigForm", "title": "Chart Configuration", "body": null, "button_name": "Save", "buttonType": "submit", "display": true
    },
    "compareConfigModal": {
        "id": "compareConfigModal", "form_name": "compareConfig", "form_id": "compareConfigForm", "title": "Compare Chart", "body": null, "button_name": "Save", "buttonType": "submit", "display": true
    },
    "exportReportModal": {
        "id": "exportReportModal", "form_name": "exportReport", "form_id": "exportReportForm", "title": "Export Report", "body": null, "button_name": "Export", "buttonType": "submit", "display": true
    },
    "pinboardModal": {
        "id": "pinboardModal", "form_name": "pinboard", "form_id": "pinboardForm", "body": null, "buttonType": "submit", "display": true
    },
    "dashboardFilterModal": {
        "id": "dashboardFilterModal", "form_name": "filter_input", "form_id": "filter_form", "body": null, "button_name": 'Add', "display": true
    },
    "dashboardShareModal": {
        "id": "dashboardShareModal", "form_name": "dashboardShare", "form_id": "dashboardShareForm", "buttonType": "submit", "button_name": 'Share', "display": true
    },
    "setLayoutModal": {
        "id": "setLayoutModal", "form_name": "setLayout", "form_id": "setLayoutForm", "body": null, "button_name": "Save", "buttonType": "submit", "display": true
    },
    "re_arrangeComponentsModal": {
        "id": "re_arrangeComponentsModal", "form_name": "re_arrangeComponents", "form_id": "re_arrangeComponentsForm", "body": null, "button_name": "Save", "buttonType": "submit", "display": true, "height": "400"
    },
    "componentsPerPageModal": {
        "id": "componentsPerPageModal", "form_name": "componentsPerPage", "form_id": "componentsPerPageForm", "body": null, "button_name": "Save", "buttonType": "submit", "display": true
    },
    "configureKPIMColsModal": {
        "id": "configureKPIMColsModal", 'title': 'KPIM Column Configuration', "form_name": "configureKPIMCols", "form_id": "configureKPIMColsForm", "button_name": "Save", "buttonType": "submit", "display": true
    },
    "dashboardRangeModal": {
        "id": "dashboardRangeModal", "form_name": "dashboardRange", "form_id": "dashboardRangeForm", "button_name": "Save", "buttonType": "submit", "display": true
    }
}

const TopModalComponent = ({ modalEventName, authData, allPropsData, dashboard_time_range, handleModalEvent, pinboardEvent, dimensionFilter, dimensionFilterhandle, addDashboardFilter, fetchPropertyData, dashboardComponents, getComponentsAPI, dataLabelConfig, yAxis, dataLabel, dashboardCustomInfo, allProps, allStates, setKpiColumnConfig, datasetSyncClick,compareConfig,cancelEventHandler }) => {
    const [modalToView, setmodalToView] = useState({});
    const [dataToSend, setdataToSend] = useState({});

    let displayModal, filterForm = null;
    let dataset = localStorage.Dataset ? JSON.parse(localStorage.Dataset) : [];
    let list_of_users_options, listOfUserArray = [];
    let selectedUsersIds = [], selected_users = []
    if (list_users && JSON.parse(list_users).length > 0) {
        list_of_users_options = JSON.parse(list_users).map(function (innerData, index) {
            listOfUserArray.push({ "name": innerData.label, "value": innerData.value, "userId": innerData.userId })
            return <option value={innerData.value}>{innerData.label}</option>;
        });
    }
    listOfUserArray = listOfUserArray && Array.isArray(listOfUserArray) ? listOfUserArray : []
    if (allStates && allStates.dashboardComponents != -1) {
        selectedUsersIds = allStates.dashboardComponents[0].userId
        selected_users = listOfUserArray.filter(user => selectedUsersIds?.includes(user.userId))
    }
    let listOfWorkbooks = [
        { "name": "Select Workbook", "value": "" },
        { "name": "Create New Workbook", "value": "create_new_workbook" }
    ]
    let dashboard_name = allProps ? allProps.report_name : ''
    let workbook_name = allStates ? allStates.group : ''
    let workbook_type = 'local'
    // allPropsData.pinboard_data && allPropsData.pinboard_data.dashbordGroups && allPropsData.pinboard_data.dashbordGroups.map(function (innerData, index) {
    //     if (innerData.idDashboard === allPropsData.id_dashboard) {
    //         dashboard_name = innerData.name
    //         workbook_name = innerData.dashboard_group
    //         workbook_type = innerData.type
    //     }
    // })
    if (dashboardCustomInfo && dashboardCustomInfo !== null && dashboardCustomInfo.PAGE_LAYOUT) {
        var existingLayout = dashboardCustomInfo.PAGE_LAYOUT
        var existingLayoutStyle = { border: "4px solid #0168fa", borderRadius: "10px 10px 9px 9px" }
    }

    const setLayoutSelected = (e) => {
        let layoutValue = e.currentTarget.innerText
        layoutValue = layoutValue === '100%' ? '100'
            : layoutValue === '50%\n50%' ? '50-50'
                : layoutValue === '25%\n25%\n25%\n25%' ? '25-25-25-25'
                    : layoutValue === '30%\n70%' ? '30-70'
                        : layoutValue === '70%\n30%' ? '70-30'
                            // : layoutValue === '30%\n40%\n30%' ? '30-40-30'
                            : layoutValue === '33%\n33%\n33%' ? '33-33-33'
                                : '100'
        document.getElementById('layoutSelected').value = layoutValue
        let currentId = e.currentTarget.id
        $('[id^=layoutRow_col]').removeAttr("style"); // Remove all styles
        $("#" + currentId).css("border", "4px solid #0168fa");
        $("#" + currentId).css("border-radius", "10px 10px 9px 9px");
    }

    useEffect(() => {
        try {
            let formData = ['dashboardFilter', 'setLayout', 're_arrangeComponents'].indexOf(modalEventName) !== -1 ? {} : JSON.parse(JSON.stringify(formUpload[`${modalEventName}Form`]));
            let config = JSON.parse(JSON.stringify(modalConfig[`${modalEventName}Modal`]));
            let componentType = null, data = {}, labelShow = {}, report_information = {}, pinboard_information = [];
            if (modalEventName && (modalEventName === 'saveReport' || modalEventName === 'exportReport' )) {
                data.siteId = authData.siteId
                data.toolId = dataset.toolId
                let currentPageName = allPropsData.currentPageName;
                let pageName = allPropsData.pageName ? allPropsData.pageName : null;
                if (currentPageName == "pinboard") {
                    componentType = "Dashboard"
                    data.dashboard_id = allPropsData.id_dashboard
                    data.startDate = allPropsData.dashboardStartDate
                    data.endDate = allPropsData.dashboardEndDate
                    allPropsData.breakUp !== "" ? data.breakUp = allPropsData.breakUp : null
                    allPropsData.include !== null ? data.include = allPropsData.include : null
                    allPropsData.exclude !== null ? data.exclude = allPropsData.exclude : null
                    if (allPropsData.breakUpDisp !== undefined || allPropsData.includeDisp.length > 0 || allPropsData.excludeDisp.length > 0) {
                        labelShow = getLabel(null, null, null, allPropsData.breakUpDisp, null, null, allPropsData.includeDisp, allPropsData.excludeDisp)
                        labelShow.breakupText !== "" ? data.breakupText = labelShow.breakupText : null
                        labelShow.includeText !== "" ? data.includeText = labelShow.includeText : null
                        labelShow.excludeText !== "" ? data.excludeText = labelShow.excludeText : null
                    }
                } else {
                    var status = null;
                    if ((currentPageName && currentPageName.toLowerCase() == "chartdata") || (pageName && pageName.toLocaleLowerCase() == 'chart')) {
                        componentType = "Chart";
                        status = validationInput(allPropsData.property, allPropsData.metricValue, allPropsData.period ? allPropsData.period : "", allPropsData.chartCat.toLowerCase(), "all")
                        data.chartDisp = allPropsData.chartCat;
                        data.chart = status.chartDisp ? status.chartDisp : allPropsData.chartCat;
                    } else if (currentPageName && currentPageName.toLowerCase() == "report") {
                        componentType = "Report";
                        if (allPropsData.crosstab_flag === false && allPropsData.property.includes(',')) {
                            let leftDim = allPropsData.property.split(',')
                            data.aboveDim = leftDim.pop()
                            data.leftDim = leftDim.toString()
                        } else {
                            data.aboveDim = ""
                            data.leftDim = allPropsData.property
                        }
                    } else if (currentPageName && currentPageName.toLowerCase() == "summary") {
                        componentType = "Summary";
                    }
                    if (dashboard_time_range) {
                        dashboard_time_range = dashboard_time_range.split("_");
                        data.startDate = '{"date_method":"endDate","count":"' + (dashboard_time_range[0] - 1) + '","date_format":"' + dashboard_time_range[1] + '"}';
                        data.endDate = '{"date_method":"endDate"}';
                    } else {
                        data.startDate = allPropsData.startDate;
                        data.endDate = allPropsData.endDate;
                    }
                    if (metricGlobal && allPropsData.selectedMetric) {
                        labelShow = getLabel(metricGlobal, allPropsData.selectedMetric, allPropsData.propertyDisp, allPropsData.SelectedBreakUpDisp, null, null, allPropsData.includeDisp, allPropsData.excludeDisp);
                    }
                    data.category = allPropsData.property;
                    data.metric = allPropsData.selectedMetric;
                    data.selectedMetric = allPropsData.selectedMetric;
                    data.breakUp = allPropsData.SelectedBreakUp;
                    data.include = allPropsData.include;
                    data.exclude = allPropsData.exclude;
                    data.chartType = allPropsData.period;
                    data.chartDispStyle = allPropsData.period;
                    data.period = allPropsData.period;
                    data.analysis = allPropsData.analysis;
                    data.regressionLine = allPropsData.regressionLine;
                    data.clusterCount = allPropsData.clusterCount;
                    data.chartCat = allPropsData.chartCat;
                    data.sortOrder = allPropsData.sortOrder;
                    data.limit = allPropsData.limit;
                    data.transpose = allPropsData.transpose;
                    data.kpiMonitoring = allPropsData.kpiMonitoring;
                    data.compare = allPropsData.compare;
                    data.multiDim = allPropsData.crosstab_flag;
                    if (labelShow) {
                        data.metricText = labelShow.metricText;
                        data.propertyText = labelShow.propertyText;
                        data.breakupText = labelShow.breakupText;
                        data.includeText = labelShow.includeText;
                        data.excludeText = labelShow.excludeText;
                    } else {
                        data.metricText = '';
                        data.propertyText = '';
                        data.breakupText = '';
                        data.includeText = '';
                        data.excludeText = '';
                    }
                    data.metricRange = allPropsData.metricRange;
                }
                if (modalEventName && modalEventName === "saveReport") {
                    formData['outputType']['text_value'] = 'pdf'
                    formData["toUser"]["options"] = listOfUserArray;
                    report_information = {
                        "siteId": authData.siteId,
                        "toolId": dataset.toolId,
                        "userId": authData.userId,
                        "type": componentType,
                        "reportData": data,
                        "frequency": {},
                        "toUser": [],
                        "channel": []
                    }
                    currentPageName === "pinboard" ? report_information['dashboardGroup'] = decodeURI(allPropsData.dashboard_group) : null;
                    setdataToSend({ 'report_information': report_information })
                }
                else if (modalEventName && modalEventName === "exportReport") {
                    if (componentType === "Summary") {
                        formData['outputType']['options'] = [
                            { "name": "Excel", "value": "xls" },
                            { "name": "CSV", "value": "csv" },
                            { "name": "PDF", "value": "pdf" }
                        ]
                    } else if (componentType === "Report") {
                        formData['outputType']['options'] = [
                            { "name": "Excel", "value": "excel" },
                            { "name": "CSV", "value": "csv", },
                            { "name": "PDF", "value": "pdf" }
                        ]
                    } else if (componentType === "Chart") {
                        formData['outputType']['options'] = [
                            { "name": "PNG", "value": "image/png" },
                            { "name": "JPEG", "value": "image/jpeg" },
                            { "name": "PDF", "value": "pdf" }
                        ]
                    } else if (componentType === "Dashboard") {
                        formData['outputType']['options'] = [
                            { "name": "PDF", "value": "pdf" }
                        ]
                        formData['outputType']['text_value'] = "pdf"
                        report_information['dashboardGroup'] = decodeURI(allPropsData.dashboard_group)
                        setdataToSend({ 'report_information': report_information })
                    }
                }
            } else if (modalEventName && modalEventName === "pinboard") {
                if (pinboardEvent === "rename") {
                    formData['typ']['type'] = 'dropdown'
                    pinboard_information.push({
                        "siteId": authData.siteId,
                        "toolId": dataset.toolId,
                        "userId": authData.userId,
                        "type": workbook_type,
                        "rockmetric_update": true,
                        "rockmetric_update_columns": []
                    })
                    config['button_name'] = "Rename"
                    config['title'] = <>Rename <span>(Workbook: {workbook_name}, Dashboard: {dashboard_name})</span></>
                    setdataToSend({ 'pinboard_information': [...pinboard_information] })
                } else if (pinboardEvent === "copy") {
                    formData['typ']['type'] = "dropdown"
                    formData['typ']['options'] = [
                        { "name": "Select option", "value": "" },
                        { "name": "Copy Current Dashboard", "value": "dashboard" },
                        { "name": "Copy Current Workbook", "value": "workbook" }
                    ]
                    formData['type']['type'] = 'dropdown'
                    //formData['isCopy']['type'] = 'checkbox'
                    setdataToSend({ 'report_information': {} })
                    config['button_name'] = "Copy"
                    config['title'] = <>Copy <span>(Workbook: {workbook_name}, Dashboard: {dashboard_name})</span></>
                } else if (pinboardEvent === "duplicate") {
                    formData['typ']['type'] = "dropdown"
                    formData['typ']['options'] = [
                        { "name": "Select option", "value": "" },
                        { "name": "Duplicate Dashboard", "value": "dashboard" },
                        { "name": "Duplicate Workbook", "value": "workbook" }
                    ]
                    report_information = {
                        "type": workbook_type
                    }
                    config['button_name'] = "Duplicate"
                    config['title'] = <>Duplicate <span>(Workbook: {workbook_name}, Dashboard: {dashboard_name})</span></>
                    setdataToSend({ 'report_information': report_information })
                } else if (pinboardEvent === "move") {
                    formData['type']['type'] = 'dropdown'
                    formData['workbook']['type'] = 'dropdown'
                    setdataToSend({ 'report_information': {} })
                    config['button_name'] = "Move"
                    config['title'] = <>Move <span>(Workbook: {workbook_name}, Dashboard: {dashboard_name})</span></>
                } else if (pinboardEvent === "delete") {
                    formData['typ']['type'] = 'dropdown'
                    pinboard_information.push({
                        "siteId": authData.siteId,
                        "toolId": dataset.toolId,
                        "userId": authData.userId,
                        "isDisplay": 0,
                        "type": workbook_type,
                        "rockmetric_update": true,
                        "rockmetric_update_columns": ["isDisplay"]
                    })
                    config['button_name'] = "Delete"
                    config['title'] = <>Delete <span>(Workbook: {workbook_name}, Dashboard: {dashboard_name})</span></>
                    setdataToSend({ 'pinboard_information': [...pinboard_information] })
                }
            } else if (modalEventName && modalEventName === "dashboardFilter") {
                formData = (<AsyncSelect placeholder="Select Dashboard Filter"
                    key={`asyncSelectFilter__${Math.floor(Math.random() * 10)}`}
                    name="dimension"
                    value={dimensionFilter}
                    onChange={dimensionFilterhandle}
                    loadOptions={fetchPropertyData}
                    isMulti={true}
                    defaultOptions={true}
                    cacheOptions={true}
                />);
                config['title'] = <>Add Filters <span>(Workbook: {workbook_name}, Dashboard: {dashboard_name})</span></>
            } else if (modalEventName && modalEventName === 'dashboardShare') {
                formData["user_list"]["text_value"] = selected_users.map((user => user.value))
                formData["user_list"]["options"] = listOfUserArray;
                report_information = {
                    "idDashboard": allPropsData.id_dashboard,
                    "siteId": authData.siteId,
                    "toolId": dataset.toolId,
                    "userId": authData.userId,
                }
                setdataToSend({ 'report_information': report_information })
                config['title'] = <>Share Dashboard <span>(Workbook: {workbook_name}, Dashboard: {dashboard_name})</span></>
            } else if (modalEventName && modalEventName === 'setLayout') {
                formData = (<>
                    {/* 1st  Row*/}
                    <input type="hidden" id="layoutSelected" name="layoutSelected" />
                    <div className='layoutRow'>
                        <div className='layoutRow1_col_1' id='layoutRow_col100' onClick={(e) => setLayoutSelected(e)} style={existingLayout === '100' ? existingLayoutStyle : null}>
                            100%
                        </div>
                        <div className='layoutRow_col' id='layoutRow_col50' onClick={(e) => setLayoutSelected(e)} style={existingLayout === '50-50' ? existingLayoutStyle : null}>
                            <div className='layoutRow_innerCol' style={{ width: '50px', borderRadius: '5px 0px 0px 5px' }}>
                                50%
                            </div>
                            <div className='layoutRow_innerCol' style={{ width: '50px', borderRadius: '0px 5px 5px 0px', borderLeftStyle: 'none' }}>
                                50%
                            </div>
                        </div>
                        <div className='layoutRow_col' id='layoutRow_col25' onClick={(e) => setLayoutSelected(e)} style={existingLayout === '25-25-25-25' ? existingLayoutStyle : null}>
                            <div className='layoutRow_innerCol' style={{ width: '25px', borderRadius: '5px 0px 0px 5px' }}>
                                25%
                            </div>
                            <div className='layoutRow_innerCol' style={{ width: '25px', borderLeftStyle: 'none' }}>
                                25%
                            </div>
                            <div className='layoutRow_innerCol' style={{ width: '25px', borderLeftStyle: 'none' }}>
                                25%
                            </div>
                            <div className='layoutRow_innerCol' style={{ width: '25px', borderRadius: '0px 5px 5px 0px', borderLeftStyle: 'none' }}>
                                25%
                            </div>
                        </div>
                    </div>
                    {/* 2nd  Row*/}
                    <div className='layoutRow' style={{ marginTop: '20px' }}>
                        <div className='layoutRow_col' id='layoutRow_col3070' onClick={(e) => setLayoutSelected(e)} style={existingLayout === '30-70' ? existingLayoutStyle : null}>
                            <div className='layoutRow_innerCol' style={{ width: '30px', borderRadius: '5px 0px 0px 5px' }}>
                                30%
                            </div>
                            <div className='layoutRow_innerCol' style={{ width: '70px', borderRadius: '0px 5px 5px 0px', borderLeftStyle: 'none' }}>
                                70%
                            </div>
                        </div>
                        {/* <div className='layoutRow_col' id='layoutRow_col304030' onClick={(e) => setLayoutSelected(e)} style={existingLayout === '30-40-30' ? existingLayoutStyle : null}>
                            <div className='layoutRow_innerCol' style={{ width: '30px', borderRadius: '5px 0px 0px 5px' }}>
                                30%
                            </div>
                            <div className='layoutRow_innerCol' style={{ width: '40px', borderLeftStyle: 'none' }}>
                                40%
                            </div>
                            <div className='layoutRow_innerCol' style={{ width: '30px', borderRadius: '0px 5px 5px 0px', borderLeftStyle: 'none' }}>
                                30%
                            </div>
                        </div> */}
                        <div className='layoutRow_col' id='layoutRow_col333333' onClick={(e) => setLayoutSelected(e)} style={existingLayout === '33-33-33' ? existingLayoutStyle : null}>
                            <div className='layoutRow_innerCol' style={{ width: '33px', borderRadius: '5px 0px 0px 5px' }}>
                                33%
                            </div>
                            <div className='layoutRow_innerCol' style={{ width: '33px', borderLeftStyle: 'none' }}>
                                33%
                            </div>
                            <div className='layoutRow_innerCol' style={{ width: '33px', borderRadius: '0px 5px 5px 0px', borderLeftStyle: 'none' }}>
                                33%
                            </div>
                        </div>
                        <div className='layoutRow_col' id='layoutRow_col7030' onClick={(e) => setLayoutSelected(e)} style={existingLayout === '70-30' ? existingLayoutStyle : null}>
                            <div className='layoutRow_innerCol' style={{ width: '70px', borderRadius: '5px 0px 0px 5px' }}>
                                70%
                            </div>
                            <div className='layoutRow_innerCol' style={{ width: '30px', borderRadius: '0px 5px 5px 0px', borderLeftStyle: 'none' }}>
                                30%
                            </div>
                        </div>
                    </div>
                </>)
                config['title'] = <>Layout Options <span>(Workbook: {workbook_name}, Dashboard: {dashboard_name})</span></>
            } else if (modalEventName && modalEventName === 're_arrangeComponents') {
                formData = (<DragAndDropComponents components={dashboardComponents} />)
                config['title'] = <>Re-arrange Dashboard Components <span>(Workbook: {workbook_name}, Dashboard: {dashboard_name})</span></>
            } else if (modalEventName && modalEventName === 'componentsPerPage') {
                formData['components']['text_value'] = dashboardCustomInfo !== null && dashboardCustomInfo.MAX_COMPONENTS_PER_PAGE ? dashboardCustomInfo.MAX_COMPONENTS_PER_PAGE : ''
                config['title'] = <>Components Per Page <span>(Workbook: {workbook_name}, Dashboard: {dashboard_name})</span></>
            } else if (modalEventName && modalEventName === "chartConfig") {
                formData['chartConfiguration']['text_value'] = dataLabel
                // formData['yAxis']['text_value'] = yAxis
            } 
            else if (modalEventName && modalEventName === "compareConfig") {
                formData['compareConfiguration']['text_value'] = compareConfig
            } 
            else if (modalEventName && modalEventName == 'configureKPIMCols') {
                formData['kpiMetaColumns']['options'] = allProps.kpiMonitoringFunctions
                formData['kpiMetaColumns']['text_value'] = allProps.kpiColumnConfig
            } else if (modalEventName && modalEventName == 'dashboardRange') {
                if (dashboardCustomInfo !== null && dashboardCustomInfo.startDate) {
                    let parsedStartDate = JSON.parse(dashboardCustomInfo.startDate)
                    formData['dashboardRange']['text_value'] = `${parseInt(parsedStartDate.count) + 1}_${parsedStartDate.date_format}`
                }
                config['title'] = <>Dashboard Time Range <span>(Workbook: {workbook_name}, Dashboard: {dashboard_name})</span></>
            }

            config['formKey'] = `${modalEventName}Form_${Math.floor(Math.random() * 10)}`;
            config['isLoading'] = false;
            setmodalToView({ modal: config, formData: formData, type: modalEventName, componentType: componentType, data: data });
            setTimeout(() => {
                jQuery(`#${modalEventName}Modal`).modal('toggle');
            }, 5);
        } catch (error) {
            console.error("------- Error in Options Loading ---------");
            console.log(error)
        }
    }, [modalEventName])

    useEffect(() => {
        if (modalEventName === 'dashboardFilter' && Object.keys(modalToView).length > 0) {
            let formData = (<AsyncSelect placeholder="Select Dashboard Filter"
                key={`asyncSelectFilter__${Math.floor(Math.random() * 10)}`}
                name="dimension"
                value={dimensionFilter}
                onChange={dimensionFilterhandle}
                loadOptions={fetchPropertyData}
                isMulti={true}
                defaultOptions={true}
                cacheOptions={true}
            />);
            modalToView.modal['formKey'] = `${modalEventName}Form_${Math.floor(Math.random() * 10)}`;
            setmodalToView({ ...modalToView, formData: formData })
        }
    }, [dimensionFilter])

    const onChangeHandle = (e) => {
        let tempFormData = { ...modalToView.formData };
        tempFormData[e.target.name].text_value = e.target.value;
        setmodalToView({ ...modalToView, formData: tempFormData });
    }

    const dropdown_change_handle = (e) => {
        let tempFormData = { ...modalToView.formData };
        let tempModalData = { ...modalToView.modal };
        if (e.target.name) {
            if (tempFormData[e.target.name].multiple) {
                tempFormData[e.target.name].text_value = $(`#${e.target.name}_form_data`).val();
            }
            else tempFormData[e.target.name].text_value = e.target.value;
        }
        if (e.target.name === "freq_type") {
            switch (e.target.value) {
                case "daily":
                    tempFormData['timeOfDay']['type'] = "time"
                    tempFormData['timeOfDay']['requiredFlag'] = true
                    tempFormData['timeOfDay']['text_value'] = "08:00"
                    tempFormData['dayOfWeek']['type'] = "hide"
                    tempFormData['dayOfMonth']['type'] = "hide"
                    break;
                case "weekly":
                    tempFormData['timeOfDay']['type'] = "time"
                    tempFormData['timeOfDay']['text_value'] = "08:00"
                    tempFormData['timeOfDay']['requiredFlag'] = true
                    tempFormData['dayOfMonth']['type'] = "hide"
                    tempFormData['dayOfWeek']['type'] = "dropdown"
                    tempFormData['dayOfWeek']['text_value'] = "mon"
                    tempFormData['dayOfWeek']['requiredFlag'] = true
                    break;
                case "monthly":
                    tempFormData['timeOfDay']['type'] = "time"
                    tempFormData['timeOfDay']['text_value'] = "08:00"
                    tempFormData['timeOfDay']['requiredFlag'] = true
                    tempFormData['dayOfWeek']['type'] = "hide"
                    tempFormData['dayOfMonth']['type'] = "number"
                    tempFormData['dayOfMonth']['text_value'] = 1
                    tempFormData['dayOfMonth']['requiredFlag'] = true
                    break;
                case "quarterly":
                case "yearly":
                case "dates":
                case "weekdays":
                case "weekends":
                case "":
                    tempFormData['timeOfDay']['type'] = "hide";
                    tempFormData['dayOfWeek']['type'] = "hide";
                    tempFormData['dayOfMonth']['type'] = "hide";
                    break;
            }
        } else if (e.target.name === "typ" && (pinboardEvent === "rename" || pinboardEvent === "duplicate")) {
            switch (e.target.value) {
                case "dashboard":
                    tempFormData['new_name']['type'] = "text"
                    tempFormData['new_name']['text_value'] = dashboard_name
                    tempFormData['dashboard_group']['type'] = "hide"
                    break
                case "workbook":
                    tempFormData['new_name']['type'] = "hide"
                    tempFormData['dashboard_group']['type'] = "text"
                    tempFormData['dashboard_group']['text_value'] = workbook_name
                    break
                case "":
                    tempFormData['new_name']['type'] = "hide"
                    tempFormData['dashboard_group']['type'] = "hide"
                    break
            }
        } else if (e.target.name === "type") {
            let checkArraydashbordGroups = []
            allPropsData.pinboard_data && allPropsData.pinboard_data.dashbordGroups.map(function (innerData) {
                if (checkArraydashbordGroups.indexOf(innerData.dashboard_group) == -1) {
                    let status = true;
                    switch (e.target.value) {
                        case "local":
                            status = innerData.type == 'local' && dataset.toolId == innerData.toolId ? true : false
                            break
                        case "global":
                            status = innerData.type == 'global' ? true : false
                            break
                    }
                    if (status) {
                        listOfWorkbooks.push({ "name": `${innerData.dashboard_group.charAt(0).toUpperCase()}${innerData.dashboard_group.slice(1)}`, "value": innerData.dashboard_group })
                        checkArraydashbordGroups.push(innerData.dashboard_group)
                    }
                }
            })
            tempFormData['workbook']['options'] = [...listOfWorkbooks]
        } else if (e.target.name === "workbook") {
            switch (e.target.value) {
                case "create_new_workbook":
                    tempFormData['new_name']['type'] = 'text'
                    tempFormData['new_name']['text_value'] = dashboard_name
                    tempFormData['dashboard_group']['type'] = "text"
                    tempFormData['dashboard_group']['text_value'] = workbook_name
                    break
                case "":
                    tempFormData['new_name']['type'] = "hide"
                    tempFormData['dashboard_group']['type'] = "hide"
                    break
                default:
                    tempFormData['dashboard_group']['type'] = "hide"
                    tempFormData['new_name']['type'] = 'text'
                    tempFormData['new_name']['text_value'] = dashboard_name
            }
        } else if (e.target.name === "typ" && pinboardEvent === "copy") {
            switch (e.target.value) {
                case "workbook":
                    tempFormData['workbook']['type'] = 'hide'
                    tempFormData['dashboard_group']['type'] = 'text'
                    tempFormData['dashboard_group']['text_value'] = workbook_name
                    tempFormData['new_name']['type'] = 'hide'
                    tempFormData['category']['type'] = "hide"
                    break
                case "dashboard":
                    tempFormData['workbook']['type'] = 'dropdown'
                    tempFormData['dashboard_group']['type'] = 'hide'
                    tempFormData['new_name']['type'] = 'text'
                    tempFormData['new_name']['text_value'] = dashboard_name
                    tempFormData['category']['type'] = 'dropdown'
                    break
                case "":
                    tempFormData['workbook']['type'] = 'hide'
                    tempFormData['dashboard_group']['type'] = 'hide'
                    tempFormData['new_name']['type'] = 'hide'
                    tempFormData['category']['type'] = 'hide'
            }
        }
        tempModalData['formKey'] = `${modalEventName}Form_${Math.floor(Math.random() * 10)}`
        setmodalToView({ ...modalToView, modal: tempModalData, formData: tempFormData });
    }

    const modalSubmission = (e) => {
        let target = e.target.id === 'setLayout_button'
            ? 'setLayout'
            : e.target.id === 're_arrangeComponents_button'
                ? 're_arrangeComponents'
                : e.target.name,
            url = null,
            postData = null,
            sampleModalData = { ...modalToView },
            params = {},
            checkValidity = true
        if (target === "saveReport") {
            $(`#${target}Form`).serializeArray().map((innerData) => {
                if (["freq_type", "timeOfDay", "dayOfWeek", "dayOfMonth"].indexOf(innerData.name) > -1) {
                    dataToSend['report_information']['frequency'][innerData.name] = innerData.value;
                } else if (["toUser", "channel"].indexOf(innerData.name) > -1) {
                    dataToSend['report_information'][innerData.name].push(innerData.value);
                } else {
                    dataToSend['report_information'][innerData.name] = innerData.value;
                }
            })
            checkValidity = checkValidity ? (checkSpecialChars(dataToSend['report_information']['reportName']) ? false : true) : false
            const browserUrl = window.location.pathname + window.location.search
            if (checkValidity === false) {
                alert('Please enter valid input for report name!\n(Only alphabets, numbers, hyphen(-) & underscore(_) are allowed.)');
            } else {
                url = '/app/store_report_data';
                postData = dataToSend['report_information'];
                postData.browser_url = browserUrl
                sampleModalData.modal['isLoading'] = true
                sampleModalData.modal['formKey'] = `${sampleModalData.type}Form_${Math.floor(Math.random() * 10)}`;
                setmodalToView(sampleModalData);
                CallAPI('post', url, postData, params, 0, function (response) {
                    if (response.status === true) {
                        alert(response.information)
                    } else {
                        alert(response.error_message);
                    }
                    jQuery(`#${target}Modal`).modal('toggle');
                    handleModalEvent(null)
                }, authData);
            }
        } else if (target === "chartConfig") {
            let formData = $(`#${target}Form`).serializeArray()
            if (formData != null || formData != undefined) {
                // dataLabelConfig({ 'dataLabelConfig': formData[0].value, 'yAxis': formData[1].value })
                dataLabelConfig({ 'dataLabelConfig': formData[0].value })
            }
            jQuery(`#${target}Modal`).modal('toggle');
            handleModalEvent(null)
            location.reload()

        } else if (target === "compareConfig") {
            let formData = $(`#${target}Form`).serializeArray()
               
            function cleanArrayOfObjects(arr) {
                return arr.map(obj => {
                    let cleanedObj = { ...obj };
                    if (cleanedObj.hasOwnProperty('value')) {
                        cleanedObj = cleanedObj['value'].split(';')[0];
                    }
                    return cleanedObj;
                });
            }
            console.log(allStates,allPropsData,allProps)
            let newSelectedMetric=allPropsData.selectedMetric;
            let growthCompareTo = allPropsData.dataSet.userDBSetting[0].growthCompareTo
            function getBudgetForSelectedMetric(newSelectedMetric) {
                // let budgetObject = allPropsData.metricDisp.filter(val => val.budget)
                let budgetValue = allPropsData.metricDisp.length>0 && allPropsData.metricDisp.map(item => item.budget);
                return budgetValue
            }

            let compareFunction = formData[0].value == 'growth' ? (growthCompareTo == '0' ||   growthCompareTo == '3' ? 'ly' : growthCompareTo == '2' ? 'lm' : "wk") : getBudgetForSelectedMetric(newSelectedMetric);
        
            let selectedMetricArray = cleanArrayOfObjects(allPropsData.selectedMetricDisp)
            // allPropsData.selectedMetricDisp.map(val=>val.value);
            // selectedMetricArray = selectedMetricArray.split(';');
            let newMetrics = formData[0].value == 'growth' ? selectedMetricArray.length > 0 ? selectedMetricArray.map(innerData => `${innerData};${compareFunction}`) : `${selectedMetricArray[0]};${compareFunction}` : compareFunction.length>0?compareFunction:compare
            newSelectedMetric = allPropsData.selectedMetric + ',' +  (formData[0].value == 'growth'  ? newMetrics.join(',') : newMetrics)
            let arr = newSelectedMetric.split(',');
            let uniqueArr = [...new Set(arr)];
            newSelectedMetric = uniqueArr.join(',');
            if (compareFunction && (!Object.values(newMetrics).includes("") && !Object.values(newMetrics).includes(null))) {
                let new_props = { "selectedMetric": newSelectedMetric, "property": allPropsData.property, "breakup": allPropsData.breakup, "period": allPropsData.period, "clicked": allPropsData.clicked, "include": allPropsData.include, "exclude": allPropsData.exclude, "transpose": allPropsData.transpose, "kpiMonitoring": allPropsData.kpiMonitoring, "crosstab_flag": allPropsData.crosstab_flag, "saveFilterToggle": allPropsData.saveFilterToggle, "sortOrder": allPropsData.sortOrder, "limit": allPropsData.limit }
                let response = {
                    include:  allPropsData.includeDisp ? JSON.stringify( allPropsData.includeDisp) : JSON.stringify(getBreakupDisp( allPropsData.include,  allPropsData.alfred.property)),
                    exclude:  allPropsData.excludeDisp ? JSON.stringify( allPropsData.excludeDisp) : JSON.stringify(getBreakupDisp( allPropsData.exclude,  allPropsData.alfred.property)),
                    filter:  allPropsData.SelectedBreakUpDisp ? JSON.stringify( allPropsData.SelectedBreakUpDisp) : JSON.stringify(getBreakupDisp( allPropsData.breakup,  allPropsData.alfred.property)),
                    property:  allPropsData.propertyDisp ? JSON.stringify( allPropsData.propertyDisp) : JSON.stringify(getPropertyDisp( allPropsData.property,  allPropsData.alfred.property))
                }
                let finalObj = handleParamsToSet(response, new_props,allProps.allData )
                allPropsData.set_disp_objects({ ...finalObj, 'initialDataApiFlag': true })
                if (formData != null || formData != undefined) { 
                    dataLabelConfig({ 'compareConfig': formData[0].value })
                }    
                jQuery(`#${target}Modal`).modal('toggle');
                handleModalEvent(null)
            }else{
                let checkBudget = allPropsData?.metricDisp.filter(val => !val.budget)
                let metricName = checkBudget.map(val => val.label)
                alert(`Target is not set for the Selected ${metricName.length > 1 ? "Metrics" : "Metric"} : ${metricName.join(", ")}, Please select another metric to Compare Target `)
                jQuery(`#${target}Modal`).modal('toggle');
                handleModalEvent(null)
            }
        } else if (target === "exportReport") {
            let expFileName = document.getElementById("fileName_form_data").value
            let expFileType = document.getElementById("outputType_form_data").value
            checkValidity = checkValidity ? (checkSpecialChars(expFileName) ? false : true) : false
            if (checkValidity === false) {
                alert('Please enter valid input!\n(Only alphabets, numbers, hyphen(-) & underscore(_) are allowed.)');
                jQuery(`#${target}Modal`).trigger('reset');
            } else {
                if (sampleModalData.componentType === "Summary" && (expFileType === "csv" || expFileType === "xls")) {
                    let data = [];
                    for (let i = 0; i < summaryData["comp"].length; i++) {
                        data.push({
                            "Name": summaryData["comp"][i].description,
                            "value": summaryData["comp"][i].data,
                        });
                    }
                    exportFromJSON({ data, fileName: expFileName, exportType: expFileType })
                } else if (sampleModalData.componentType === "Chart" && (expFileType === "image/png" || expFileType === "image/jpeg")) {
                    downloadHandleAction(e, sampleModalData.componentType, toExcel, ExportToCsv)
                } else if (sampleModalData.componentType === "Report" && (expFileType === "excel" || expFileType === "csv")) {
                    downloadHandleAction(e, sampleModalData.componentType, toExcel, ExportToCsv)
                } else if (expFileType === "pdf") {
                    dataToSend['report_information'] = {
                        "api_request": true,
                        "siteId": authData.siteId,
                        "userId": authData.userId,
                        "type": sampleModalData.componentType,
                        "reportData": sampleModalData.data
                    }
                    dataToSend['report_information']['reportName'] = expFileName
                    dataToSend['report_information']['outputType'] = expFileType
                    url = '/app/store_download_report'
                    postData = dataToSend['report_information'];
                    sampleModalData.modal['isLoading'] = true
                    sampleModalData.modal['formKey'] = `${sampleModalData.type}Form_${Math.floor(Math.random() * 10)}`;
                    setmodalToView(sampleModalData);
                    // params['toolId'] = postData['toolId']
                    // params['user'] = postData['userId']
                    // params = [] // Making params empty here
                    CallAPI('post', url, postData, params, 0, function (response) {
                        if (response.status === true) {
                            if (response.information.status === true) {
                                alert(response.information.information);
                                window.open("/requestLogs/app")
                            } else alert(response.information.error_message)
                        } else alert(response.error_message);
                        jQuery(`#${target}Modal`).modal('toggle');
                        handleModalEvent(null)
                    }, authData);
                }
                jQuery(`#${target}Modal`).modal('toggle');
                handleModalEvent(null)
            }
        } else if (target === "pinboard") {
            let checkFields = []
            if (document.getElementById('new_name_form_data')) {
                checkFields.push(document.getElementById('new_name_form_data').value)
            }
            if (document.getElementById('dashboard_group_form_data')) {
                checkFields.push(document.getElementById('dashboard_group_form_data').value)
            }
            checkFields.map(function (innerData) {
                checkValidity = checkValidity ? (checkSpecialChars(innerData) ? false : true) : false
            })
            if (checkValidity === false) {
                alert('Please enter valid input!\n(Only alphabets, numbers, hyphen(-) & underscore(_) are allowed.)');
                jQuery(`#${target}Modal`).trigger('reset');
            } else {
                if (pinboardEvent === "rename") {
                    $(`#${target}Form`).serializeArray().map((innerData) => {
                        if (innerData.value === "workbook") {
                            dataToSend['pinboard_information'][0]['old_dashboard_group'] = workbook_name
                            dataToSend['pinboard_information'][0]['rockmetric_update_columns'].push('dashboard_group');
                        } else if (innerData.value === "dashboard") {
                            dataToSend['pinboard_information'][0]['dashboard_id'] = allPropsData.id_dashboard
                            dataToSend['pinboard_information'][0]['dashboard_group'] = workbook_name
                            dataToSend['pinboard_information'][0]['rockmetric_update_columns'].push('name')
                        }
                        dataToSend['pinboard_information'][0][innerData.name] = innerData.value;
                    })
                    url = '/app/dashboard/updateDashboardData'
                    params = null
                    postData = dataToSend['pinboard_information']
                } else if (pinboardEvent === "copy") {
                    $(`#${target}Form`).serializeArray().map((innerData) => {
                        if (innerData.value === "dashboard") {
                            dataToSend['report_information']['dashboard_value'] = document.getElementById('new_name_form_data').value;
                            dataToSend['report_information']['dashboard_id'] = "create_new_dashboard";
                            // dataToSend['report_information']['dashboard_id'] = -1;
                            dataToSend['report_information']['old_dashboard_id'] = allPropsData.id_dashboard
                            if (document.getElementById('workbook_form_data').value === "create_new_workbook") {
                                dataToSend['report_information']['dashboard_group'] = document.getElementById('dashboard_group_form_data').value;
                            } else dataToSend['report_information']['dashboard_group'] = document.getElementById('workbook_form_data').value;
                            dataToSend['report_information']['type'] = document.getElementById('type_form_data').value;
                        } else if (innerData.value === "workbook") {
                            dataToSend['report_information']['dashboard_group'] = document.getElementById('dashboard_group_form_data').value;
                            dataToSend['report_information']['old_dashboard_group'] = workbook_name;
                            dataToSend['report_information']['type'] = document.getElementById('type_form_data').value;
                        }
                    })
                    url = '/app/dashboard/copyDashboard'
                    dataToSend['report_information']['userId'] = authData.userId
                    postData = dataToSend['report_information']
                    params = { "siteId": authData.siteId, "toolId": dataset.toolId, "move": false, "typ": document.getElementById('typ_form_data').value }
                } else if (pinboardEvent === "duplicate") {
                    $(`#${target}Form`).serializeArray().map((innerData) => {
                        if (innerData.value === "dashboard") {
                            dataToSend['report_information']['dashboard_value'] = document.getElementById('new_name_form_data').value;
                            dataToSend['report_information']['dashboard_id'] = "create_new_dashboard";
                            // dataToSend['report_information']['dashboard_id'] = -1;
                            dataToSend['report_information']['old_dashboard_id'] = allPropsData.id_dashboard;
                            dataToSend['report_information']['dashboard_group'] = workbook_name;
                        } else if (innerData.value === "workbook") {
                            dataToSend['report_information']['dashboard_group'] = document.getElementById('dashboard_group_form_data').value;
                            dataToSend['report_information']['old_dashboard_group'] = workbook_name;
                        }
                    })
                    url = '/app/dashboard/copyDashboard'
                    dataToSend['report_information']['userId'] = authData.userId
                    postData = dataToSend['report_information']
                    params = { "siteId": authData.siteId, "toolId": dataset.toolId, "move": false, "typ": document.getElementById('typ_form_data').value }
                } else if (pinboardEvent === "move") {
                    dataToSend['report_information']['dashboard_value'] = document.getElementById('new_name_form_data').value;
                    dataToSend['report_information']['dashboard_id'] = "create_new_dashboard";
                    // dataToSend['report_information']['dashboard_id'] = -1;
                    dataToSend['report_information']['old_dashboard_id'] = allPropsData.id_dashboard
                    if (document.getElementById('workbook_form_data').value === "create_new_workbook") {
                        dataToSend['report_information']['dashboard_group'] = document.getElementById('dashboard_group_form_data').value;
                    } else dataToSend['report_information']['dashboard_group'] = document.getElementById('workbook_form_data').value;
                    dataToSend['report_information']['type'] = document.getElementById('type_form_data').value;
                    dataToSend['report_information']['userId'] = authData.userId
                    url = '/app/dashboard/copyDashboard'
                    dataToSend['report_information']['userId'] = authData.userId
                    postData = dataToSend['report_information']
                    params = { "siteId": authData.siteId, "toolId": dataset.toolId, "move": true, "typ": "dashboard" }
                } else if (pinboardEvent === "delete") {
                    $(`#${target}Form`).serializeArray().map((innerData) => {
                        if (innerData.value === "workbook") {
                            dataToSend['pinboard_information'][0]['dashboard_group'] = workbook_name;
                        } else if (innerData.value === "dashboard") {
                            dataToSend['pinboard_information'][0]['dashboard_id'] = allPropsData.id_dashboard;
                            dataToSend['pinboard_information'][0]['dashboard_group'] = workbook_name;
                        }
                        dataToSend['pinboard_information'][0][innerData.name] = innerData.value;
                    })
                    url = '/app/dashboard/updateDashboardData'
                    params = null
                    postData = dataToSend['pinboard_information']
                }
                sampleModalData.modal['isLoading'] = true
                sampleModalData.modal['formKey'] = `${sampleModalData.type}Form_${Math.floor(Math.random() * 10)}`;
                setmodalToView(sampleModalData);
                CallAPI('POST', url, postData, params, 0, function (response) {
                    if (response.status === true) {
                        if (target === "pinboard" && (pinboardEvent === "rename" || pinboardEvent === "delete" || pinboardEvent==="duplicate")) {
                            if (Array.isArray(response.information)) {
                                alert("Data "+pinboardEvent+" sucessfully." );
                            } else alert("Data "+pinboardEvent+" sucessfully." )
                            datasetSyncClick(allProps.dataSet,true);
                        } else alert(response.information)
                    } else if (pinboardEvent === "delete") {
                        alert(response.error_message.information);
                    } else alert(response.error_message)
                    jQuery(`#${target}Modal`).modal('toggle');
                    handleModalEvent(null)
                }, authData);
            }
        } else if (target === "dashboardShare") {
            let selectedUsersArray = []
            $(`#${target}Form`).serializeArray().map((innerData) => {
                selectedUsersArray.push(innerData.value)
            })
            let selectedUsers = list_users && JSON.parse(list_users).filter((element) => {
                if (selectedUsersArray.indexOf(element.value) !== -1) {
                    return element;
                }
            });
            dataToSend['report_information']['user_list'] = selectedUsers
            url = '/app/share/pushToDashboard'
            postData = dataToSend['report_information']
            // postData = encodePostBody(postData)
            sampleModalData.modal['isLoading'] = true
            sampleModalData.modal['formKey'] = `${sampleModalData.type}Form_${Math.floor(Math.random() * 10)}`
            // setmodalToView(sampleModalData)
            CallAPI('POST', url, postData, {}, 0, function (response) {
                if (response.status === 'Success') {
                    alert("Shared Successfully!")
                } else alert(response.status)
                jQuery(`#${target}Modal`).modal('toggle');
                handleModalEvent(null)
            }, authData);
        } else if (target === 'componentsPerPage' || target === 'setLayout') {
            url = '/app/setDashboardInformation'
            params["siteId"] = dataset.siteId
            params["toolId"] = dataset.toolId
            params['dashboard_id'] = allPropsData.id_dashboard
            postData = {
                "rockmetric_update": true,
                'userId': authData.userId
            }
            if (target === 'componentsPerPage') {
                postData['MAX_COMPONENTS_PER_PAGE'] = parseInt(document.getElementById('components_form_data').value)
                postData["rockmetric_update_columns"] = ["MAX_COMPONENTS_PER_PAGE"]
            } else if (target === 'setLayout') {
                let layoutVal = document.getElementById('layoutSelected').value
                postData['PAGE_LAYOUT'] = layoutVal !== "" ? layoutVal : existingLayout
                postData["rockmetric_update_columns"] = ["PAGE_LAYOUT"]
            }
            CallAPI('POST', url, postData, params, 0, function (response) {
                if (response.status === true) {
                    alert(response.information)
                } else {
                    alert(response.error_message);
                }
                jQuery(`#${target}Modal`).modal('toggle');
                handleModalEvent(null)
            }, authData);
            getComponentsAPI(allPropsData.id_dashboard, dataset, "Basic " + btoa(authData.userId + ":"))
        } else if (target === 're_arrangeComponents') {
            let reArrangedIds = []
            url = '/app/save_dashboard_sequence'
            params['siteId'] = dataset.siteId
            params['toolId'] = dataset.toolId
            params['dashboard_id'] = allPropsData.id_dashboard
            params['type'] = 'local'
            reArrangedDashboardComponents && reArrangedDashboardComponents.map(function (innerData) {
                reArrangedIds.push({
                    id: innerData.iddashboardConfiguration
                })
            })
            postData = {
                'dashboard_json': reArrangedIds,
                'userId': authData.userId
            }
            CallAPI('POST', url, postData, params, 0, function (response) {
                if (response)
                    alert('Components updated successfully')
                jQuery(`#${target}Modal`).modal('toggle');
                handleModalEvent(null)
                reArrangedDashboardComponents = null
            }, authData);
            getComponentsAPI(allPropsData.id_dashboard, dataset, "Basic " + btoa(authData.userId + ":"))
        } else if (target == 'configureKPIMCols') {
            let selectedColumns = []
            $(`#${target}Form`).serializeArray().map((innerData) => {
                selectedColumns.push(innerData.value)
            })
            setKpiColumnConfig(selectedColumns)
            jQuery(`#${target}Modal`).modal('toggle');
            handleModalEvent(null)
        } else if (target == 'dashboardRange') {
            let time_range = $(`#${target}Form`).serializeArray()[0].value.split('_')
            postData = [{
                'siteId': authData.siteId,
                'toolId': dataset.toolId,
                'userId': authData.userId,
                "rockmetric_update": true,
                "rockmetric_update_columns": ["dashboardRange"],
                "dashboardRange": JSON.stringify('{"date_method":"endDate","count":"' + (time_range[0] - 1) + '","date_format":"' + time_range[1] + '"}'),
                "dashboard_id": allPropsData.id_dashboard
            }]
            sampleModalData.modal['isLoading'] = true
            sampleModalData.modal['formKey'] = `${sampleModalData.type}Form_${Math.floor(Math.random() * 10)}`;
            setmodalToView(sampleModalData);
            CallAPI('POST', '/app/dashboard/updateDashboardData', postData, null, 0, function (response) {
                if (response.status) {
                    alert(response.information[0].information)
                } else alert(response.information.information)
                jQuery(`#${target}Modal`).modal('toggle');
                handleModalEvent(null)
            }, authData);
            getComponentsAPI(allPropsData.id_dashboard, dataset, "Basic " + btoa(authData.userId + ":"))
        }
        e.preventDefault();
    }

    const modalCancel = () => {
        handleModalEvent(null);
        if (cancelEventHandler) {
            cancelEventHandler();
        }
    }

    if (['dashboardFilter', 'setLayout', 're_arrangeComponents'].indexOf(modalEventName) !== -1 && Object.keys(modalToView).length > 0) {
        modalToView.modal['body'] = modalToView.formData !== undefined ? modalToView.formData : null;
        displayModal = modalToView.modal && Object.keys(modalToView.modal).length > 0
            ? <ModalComponent modalConfig={modalToView.modal} action={modalEventName === 'dashboardFilter'
                ? addDashboardFilter
                : modalEventName === 'setLayout' || modalEventName === 're_arrangeComponents'
                    ? (e) => modalSubmission(e)
                    : null}
                cancelEvent={modalCancel} />
            : null
    } else {
        filterForm = modalEventName && ['dashboardShare', 'configureKPIMCols'].indexOf(modalEventName) !== -1
            ? <Form label_array={modalToView.formData} />
            : modalToView.formData && Object.keys(modalToView.formData).length > 0
                ? <Form label_array={modalToView.formData} handleForm={onChangeHandle} handle_form_drop_down={dropdown_change_handle} onChangeTextField = {onChangeHandle} />
                : null;

        if (modalToView.modal && Object.keys(modalToView.modal).length > 0) {
            modalToView.modal['body'] = filterForm
        }
        displayModal = modalToView.modal && Object.keys(modalToView.modal).length > 0 ? <ModalComponent modalConfig={modalToView.modal} formSubmit={modalSubmission} cancelEvent={modalCancel} /> : null;
    }

    return displayModal
}

function mapStateToProps(state) {
    return { authData: state.dataSet.authData, dataLabel: state.dataSet?.dataLabelConfig?.dataLabelConfig,compareConfig: state.dataSet?.dataLabelConfig?.compareConfig, yAxis: state.dataSet?.dataLabelConfig?.yAxis };
}
function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        dataLabelConfig, setKpiColumnConfig
    }, dispatch)
}

export default connect(mapStateToProps, mapDispatchToProps)(TopModalComponent);